// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__13m3D","legacyBtn":"MutateMid_legacyBtn__2-qPd"};